"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.calculateFmp = calculateFmp;
exports.listenFMP = listenFMP;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _config = require("./config");

/**
 * @file 自动计算首屏
 * @author zhangyanting
 */
var domScoreList = [];
var domObserver = null;
var control = {
  container: null,

  /**
   * 计算制定dom的节点得分
   * @param {*} domContainer 根dom节点
   * @param {*} layer 相对于根dom的层级
   * @private
   */
  _getDOMScore: function _getDOMScore(domContainer, layer) {
    var _context;

    var score = 0;
    var domTag = domContainer.tagName.toLowerCase();

    if ((0, _indexOf.default)(_context = ['style', 'script', 'link']).call(_context, domTag) !== -1) {
      return;
    }

    var children = domContainer.children;
    var cLen = children.length;

    for (var i = 0; i < cLen; i++) {
      score += control._getDOMScore(children[i], layer + 1);
    }

    var domRect = domContainer.getBoundingClientRect();
    var visibleHeight = document.documentElement.clientHeight;

    if (domRect && (domRect.top < 0 || domRect.top > visibleHeight)) {
      return 0;
    }

    score += 1 + 0.5 * layer;
    return score;
  },

  /**
   * 计算首屏时间
   * @private
   */
  _calculateFMP: function _calculateFMP() {
    var scoreLen = domScoreList.length;
    var maxScoreObj = {
      score: 0,
      time: _config.SPEED_START_TIME
    };

    for (var i = 0; i < scoreLen; i++) {
      // 取分数最高且最早的时间
      if (domScoreList[i].score > maxScoreObj.score) {
        maxScoreObj = domScoreList[i];
      }
    }

    return maxScoreObj.time - _config.SPEED_START_TIME;
  }
};

function calculateFmp() {
  var score = control._getDOMScore(control.container, 1);

  domScoreList.push({
    score: score,
    time: +new Date()
  });
}

;
/**
 * 启动自动计算首屏
 * @param {*} domContainer
 * @public
 */

function listenFMP(domContainer) {
  control.container = domContainer;
  domObserver = new MutationObserver(function () {
    var score = control._getDOMScore(domContainer, 1);

    domScoreList.push({
      score: score,
      time: +new Date()
    });
  });
  domObserver.observe(domContainer, {
    childList: true,
    subtree: true,
    attributes: false
  });
  return new _promise.default(function (resolve) {
    var score = control._getDOMScore(domContainer, 1);

    domScoreList.push({
      score: score,
      time: +new Date()
    }); // 变动最大的一次为首屏

    var timeHandler = (0, _setTimeout2.default)(function () {
      clearTimeout(timeHandler);
      resolve(control._calculateFMP());
      domObserver.disconnect();
      domScoreList = [];
    }, 4000);
  });
}

;